
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { DatePicker, ItemListVariazioneOrdineMTM } from '@/components';
import { AggiornaDatiOrdineFornitoreRigaMTMRequest, AggiornaNoteOrdineFornitoreRigaMTMRequest, ConfermaVariazioneSubArrayMTMRequest, GuiRigaMTMModificaDati, RigaOrdineMTM } from '@/models';

@Component({
    components: {
        DatePicker,
        ItemListVariazioneOrdineMTM
    }
})
export default class ItemListRigaMTM extends Vue {
    @Prop() private riga!: RigaOrdineMTM;
    @Prop() private idRiga!: string;
    @Prop() private idLidAssociataCorrente!: string;
    @Prop() private statoOrdine!: string;

    get hasVariazioni() {
        return (this.riga.variazioni?.length || 0) > 0;
    }

    get rigaHeaderStyle() {
        if (this.idRiga == this.riga.idRigaMtm) {
            return '#FFFDE7';
        } else if (this.showVariazioni) {
            return '#f2f2f2';
        } else {
            return '#ffffff';
        }
    }

    private showVariazioni: boolean = false;
    private guiRigheMtmModificaDati: GuiRigaMTMModificaDati = {
        inModificaOrdineFornitore: false,
        inModificaNoteConsegnaOrdineFornitore: false,
        noteConsegnaModifica: "",
        idOrdineFornitore: "",
        dataConsegnaFornitore: ""
    };

    modificaOrdineFornitore(riga: RigaOrdineMTM) {
        this.guiRigheMtmModificaDati.idOrdineFornitore = riga.idOrdineFornitore;
        this.guiRigheMtmModificaDati.dataConsegnaFornitore = riga.dataConsegnaFornitore;
        this.guiRigheMtmModificaDati.inModificaOrdineFornitore = true;
    }

    modificaNoteConsegnaOrdineFornitore(riga: RigaOrdineMTM) {
        this.guiRigheMtmModificaDati.noteConsegnaModifica = riga.noteConsegna;
        this.guiRigheMtmModificaDati.inModificaNoteConsegnaOrdineFornitore = true;
    }

    private toggleshowVariazioni() {
        if (this.riga.variazioni && this.riga.variazioni.length > 0) {
            this.showVariazioni = !this.showVariazioni;
        }
    }

    get showInviaAggiornamentoButton() {
        if (!this.guiRigheMtmModificaDati.inModificaOrdineFornitore &&
            (!this.riga.dataConsegnaFornitore && !this.riga.idOrdineFornitore) &&
            this.statoOrdine == 'INVIATO'
        ) {
            return true;
        } else {
            return false;
        }
    }
    // @Emit('conferma-variazione')
    // private confermaVariazione()
    // {
    //     return this.variazione.id;
    // }

    @Emit("invia-dati-consegna-riga-mtm")
    private inviaDatiOrdineConsegnaRigaMtm(riga: RigaOrdineMTM) {
        return {
            idTestataMtm: riga.idTestataMtm,
            idRigaMtm: riga.idRigaMtm,
            dataConsegnaFornitore: new Date(this.guiRigheMtmModificaDati.dataConsegnaFornitore),
            idOrdineFornitore: this.guiRigheMtmModificaDati.idOrdineFornitore,
            idFornitore: ""
        } as AggiornaDatiOrdineFornitoreRigaMTMRequest;
    }

    @Emit("invia-note-consegna-riga-mtm")
    private inviaNoteConsegnaRigaMtm(riga: RigaOrdineMTM) {
        return {
            idTestataMtm: riga.idTestataMtm,
            idRigaMtm: riga.idRigaMtm,
            noteConsegna: this.guiRigheMtmModificaDati.noteConsegnaModifica,
            idFornitore: ""
        } as AggiornaNoteOrdineFornitoreRigaMTMRequest;
    }

    @Emit("conferma-variazione")
    private confermaVariazione(variazioneId: string) {
        return {
            idSubArrayElement: this.riga.idRigaMtm,
            idVariazione: variazioneId,
            idOrdine: "",
            idFornitore: "",
        } as ConfermaVariazioneSubArrayMTMRequest;
    }
}
